import { render, staticRenderFns } from "./RmaRcaResponsibility.vue?vue&type=template&id=0c0050d1&"
import script from "./RmaRcaResponsibility.vue?vue&type=script&lang=js&"
export * from "./RmaRcaResponsibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports